import { dbService } from './services/database';
import { syncService } from './services/sync';
import { authService } from './services/auth';
import { downloadManager } from './services/download-manager';
import { offlineHandler } from './services/offline-handler';
import { Capacitor } from '@capacitor/core';
import { App } from '@capacitor/app';
import { StatusBar, Style } from '@capacitor/status-bar';
import { SplashScreen } from '@capacitor/splash-screen';

class ElimePepeApp {
  private initialized = false;

  async initialize(): Promise<void> {
    if (this.initialized) return;

    try {
      console.log('🚀 Initializing Elimu Pepe App...');
      
      // Show splash screen
      await SplashScreen.show();

      // Configure status bar
      if (Capacitor.isNativePlatform()) {
        await StatusBar.setStyle({ style: Style.Light });
        await StatusBar.setBackgroundColor({ color: '#4CAF50' });
      }

      // Initialize services
      await dbService.initialize();
      await syncService.initialize();
      await offlineHandler.initialize();

      this.initialized = true;

      // Hide splash screen
      await SplashScreen.hide();

      // Expose global API
      (window as any).elimuApp = {
        db: dbService,
        sync: syncService,
        auth: authService,
        download: downloadManager,
        downloadCourse: downloadManager.downloadCourse.bind(downloadManager),
        getDownloadedCourses: downloadManager.getDownloadedCourses.bind(downloadManager),
        isCourseDownloaded: downloadManager.isCourseDownloaded.bind(downloadManager),
        saveLesson: dbService.saveLesson.bind(dbService),
        submitQuiz: this.submitQuiz.bind(this),
        updateProgress: dbService.updateProgress.bind(dbService)
      };

      console.log('🎉 Elimu Pepe App Ready!');
    } catch (error) {
      console.error('❌ Initialization failed:', error);
    }
  }

  async submitQuiz(quizData: any): Promise<number> {
    const isOnline = await syncService.checkConnection();
    
    if (isOnline) {
      console.log('📡 Submitting quiz online...');
      // Submit to API
      return quizData.id;
    } else {
      console.log('💾 Saving quiz offline...');
      const id = await dbService.saveQuizResult(quizData);
      return id;
    }
  }
}

const app = new ElimePepeApp();

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => app.initialize());
} else {
  app.initialize();
}

export default app;
